import { NgModule } from '@angular/core';
import { NaToggleFullscreenDirective } from './na-toggle-fullscreen.directive';
import { SCREEN_SERVICE_PROVIDER } from './na-screenfull-service.provider';

@NgModule({
  exports: [NaToggleFullscreenDirective],
  declarations: [NaToggleFullscreenDirective],
  providers: [SCREEN_SERVICE_PROVIDER]
})
export class NaScreenfullModule { }
